import React, {Component} from 'react';
import {Menu}             from 'semantic-ui-react';
import PropTypes          from 'prop-types';
import {Link}             from 'react-router-dom';
import {withRouter}       from 'react-router';
import classnames         from 'classnames';

// Style
import                    './MainMenu.scss';

// Global
import menuList           from '../../global/menuList';
import getMessage         from '../../global/getMessage';

import MenuMobile         from '../../molecules/MenuMobile';

// Controller
import MainMenuController from './MainMenuController';

const propTypes = {
  getTemplates : PropTypes.func.isRequired,
  lang         : PropTypes.shape({menu: PropTypes.object}),
  locale       : PropTypes.string.isRequired,
  location     : PropTypes.shape({pathname: PropTypes.string}).isRequired,
  setLangue    : PropTypes.func.isRequired,
};
const defaultProps = {lang: {}};

class MainMenu extends Component {

  constructor(props) {
    super(props);

    this.handleSetLangue = this.handleSetLangue.bind(this);
  }

  componentDidMount() {
    this.props.getTemplates();

    window.fbAsyncInit = function() {
      window.FB.init({
        appId   : '237296680161041', // App ID
        status  : false,
        version : 'v7.0',
        cookie  : true,
        xfbml   : false, // parse XFBML
      });
    };
  }

  handleSetLangue() {
    const {
      locale,
      setLangue,
    } = this.props;

    setLangue(locale);
  }

  render() {
    const {
      lang,
      locale,
      location: {pathname},
    } = this.props;

    let activePage = 'Home';

    if (pathname === '/gaelle') {
      return null;
    }

    const menuListing = menuList(pathname).map((nm) => {
      if (nm.active) {
        activePage = getMessage(nm.title, lang)[0];
      }
      if (nm.to.includes('http')) {
        return (
          <a
            className='item menu-laptop'
            href={nm.to}
            key={nm.key}
          >
            {getMessage(nm.title, lang)[0]}
          </a>
        );
      }

      return (
        <Menu.Item
          active={nm.active}
          as={Link}
          className='menu-laptop'
          key={nm.key}
          name={getMessage(nm.title, lang)[0]}
          to={nm.to}
        />
      );
    });

    return (
      <Menu
        className='sgr-menu'
        inverted
        pointing
        secondary
      >
        {menuListing}

        <span className='menu-title-mobile'>
          {activePage}
        </span>

        <MenuMobile
          lang={lang}
          locale={locale}
          onChangeLangue={this.handleSetLangue}
        />

        <Menu.Item
          className='menu-langue'
          onClick={this.handleSetLangue}
          position='right'
        >
          <span
            className={classnames(
              'lang-en',
              {active: locale === 'en'}
            )}
          >
            {'EN'}
          </span>
          {' / '}
          <span
            className={classnames(
              'lang-fr',
              {active: locale === 'fr'}
            )}
          >
            {'FR'}
          </span>
        </Menu.Item>
      </Menu>
    );
  }

}

MainMenu.propTypes = propTypes;
MainMenu.defaultProps = defaultProps;

export const MainMenuTest = MainMenu;

MainMenu = MainMenuController(MainMenu);

export default withRouter(MainMenu);



// WEBPACK FOOTER //
// ./src/organisms/MainMenu/MainMenu.js